module.exports = __webpack_public_path__ + "static/day12-81584030b7e4a620d664724a2643be4d.png";